<template>
  <div>
    <el-card class="mb-2" shadow="never">
      <div class="d-flex align-items-end">
        <div class="d-flex">
          <el-image
            :src="baseInfo.defaultImageUrl || '/image/static/img/nopic.jpg'"
            :preview-src-list="[
              baseInfo.defaultImageUrl || '/image/static/img/nopic.jpg',
            ]"
            style="width: 134px; height: 88px"
            fit="cover"
          >
            <div slot="error">
              <img
                src="/image/static/img/nopic.jpg"
                style="width: 120px; height: 80px"
              />
            </div>
          </el-image>
        </div>
        <div style="flex: 1;" class="ml-2">
          <h5 style="color: #101010;">
            {{
              baseInfo.fabricName ||
                $l('detail_placeholder_addFabric') ||
                '新增面料信息'
            }}
          </h5>
          <h6 style="color: #303133;font-size: 14px;">
            {{
              baseInfo.fabricNameEn ||
                $l('detail_placeholder_addFabric') ||
                '新增面料信息'
            }}
          </h6>
          <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center">
              <div style="height: 29px;line-height: 29px;overflow: hidden;">
                <span style="font-size: 14px; color: #606266">
                  No：{{
                    baseInfo.fabricNo ||
                      $l('detail_placeholder_fabricNoAuto') ||
                      '面料编号自动生成'
                  }}
                </span>
                <el-divider direction="vertical" />
                <el-tag
                  size="mini"
                  :type="
                    baseInfo.fabricStatus === 'Y'
                      ? 'success'
                      : baseInfo.fabricStatus === 'N'
                      ? 'danger'
                      : ''
                  "
                >
                  {{ baseInfo.v_fabricStatus || 'New' }}
                </el-tag>
                <el-divider direction="vertical" />
                <span style="font-size: 14px; color: #606266">
                  Modify：{{ baseInfo.modifyByName || '--' }} at
                  {{ baseInfo.modifyDate || '--' }}
                </span>
              </div>
            </div>
            <div class="switch-tabs_wrappers">
              <div class="switch-tabs">
                <div
                  v-for="item in switchTabs"
                  :key="item.value"
                  class="switch-tabs_items"
                  :class="{
                    active: item.value === activeName,
                    disabled: item.disabled,
                  }"
                  @click="!item.disabled ? (activeName = item.value) : () => {}"
                >
                  <span>{{ item.label }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-card>

    <div>
      <el-card v-show="activeName == 'base'" shadow="never">
        <EditForm
          ref="editForm"
          :disabled="true"
          :fabricCode="fabricCode"
          @loaded="(data) => (baseInfo = data)"
        />
        <h6 class="mt-4">{{ $l('menu_text_review') || '信息审核' }}</h6>
        <el-form
          ref="form"
          :model="formData"
          :validate-on-rule-change="false"
          :rules="rules"
          label-position="left"
        >
          <el-row :gutter="10">
            <el-col style="width: 400px;">
              <el-form-item
                :label="$l('form_label_reviewResult') || '审核结果：'"
                prop="reviewResult"
                class="ml-5px"
              >
                <el-radio-group v-model="formData.reviewResult">
                  <el-radio label="Y">
                    {{ $l('form_label_reviewResult_Y') || '审核通过' }}
                  </el-radio>
                  <el-radio label="N">
                    {{ $l('form_label_reviewResult_N') || '审核不通过' }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col style="width: 100px;">
              <el-button size="small" type="success" @click="review()">
                {{ $l('form_label_reviewSubmit') || '确认提交' }}
              </el-button>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <div style="color: #606266;font-size: 14px;margin: 10px 0;">
                {{ $l('form_label_reviewRejectionReasons') || '审核不通过原因：' }}
              </div>
              <el-form-item :label="''" prop="reviewRejectionReasons">
                <el-input
                  v-model.trim="formData.reviewRejectionReasons"
                  :placeholder="$l('form_label_reviewRejectionReasons_placeholder') || '审核不通过，请输入意见'"
                  clearable
                  type="textarea"
                  :rows="4"
                  maxlength="500"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
      <el-card v-if="activeName == 'image'" shadow="never">
        <FabricImage
          :disabled="true"
          :fabricCode="fabricCode"
          @reload="$refs.editForm.reload()"
        />
      </el-card>
    </div>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
import FabricImage from '../components/fabric-image'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  name: 'ecom-awsSample-fabricReview-detail',
  components: { EditForm, FabricImage },
  data() {
    return { baseInfo: {}, activeName: 'base', formData: {} }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    fabricCode() {
      return this.params.fabricCode
    },
    switchTabs() {
      return [
        {
          label: this.$l('switchTabs_label_base') || '基本信息',
          value: 'base',
        },
        {
          label: this.$l('switchTabs_label_image') || '面料图片',
          value: 'image',
          disabled: !this.fabricCode,
        },
      ]
    },
    rules() {
      return {
        reviewResult: [
          { required: true, trigger: 'change', message: this.$l('form_label_reviewResult_placeholder') || '请选择审核结果' },
        ],
        reviewRejectionReasons: [
          {
            required: this.formData.reviewResult === 'N',
            message: this.$l('form_label_reviewRejectionReasons_placeholder') || '审核不通过，请输入意见',
            trigger: 'change',
          },
        ],
      }
    },
  },
  methods: {
    async review() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .masterFabricReview({ ...this.formData, fabricCode: this.fabricCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_review_no') || '审核失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_review_ok') || '审核成功！',
        type: 'success',
      })
      this.$eventBus.$emit('ecom-awsSample-fabricReview-reload')
      this.goBackList()
    },
    goBackList() {
      this.$eventBus.$emit('ecom-awsSample-fabricReview-reload')
      this.$router.replace({ name: 'ecom-awsSample-fabricReview' })
    },
  },
}
</script>
<style lang="scss" scoped>
.switch-tabs {
  display: flex;
  .switch-tabs_items {
    padding: 4px 8px;
    color: #6c757d;
    font-size: 14px;
    margin-right: 20px;
    border-radius: 4px;
    cursor: pointer;
    min-width: max-content;
  }
  .switch-tabs_items:hover,
  .switch-tabs_items.active {
    color: #007bff;
    background-color: #f8f8f9;
  }
  .switch-tabs_items.disabled {
    cursor: no-drop;
  }
  .switch-tabs_items.disabled:hover {
    color: #8cc5ff;
  }
  .switch-tabs_items:last-child {
    margin-right: 0;
  }
}

::v-deep {
  .el-card__body {
    padding: 18px;
  }
}
</style>
